import { GET_INTERNAL_REQUEST_LEADS, GET_INTERNAL_REQUEST_LEADS_ERR } from '../../actionTypes/internalDashboardType'
import { getInternalRequestLeadsApi} from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getInternalRequestLeads = payload => async dispatch => {
    try {
        ////console.log('payload',payload)
        let results = await axios.put(`${getInternalRequestLeadsApi}`, payload, await accessToken())
        ////console.log("User Detail", results)
        let data = results && results.data
        dispatch({
            type: GET_INTERNAL_REQUEST_LEADS,
            payload: data || {},
        });
    } catch (error) {   
        dispatch({
            type: GET_INTERNAL_REQUEST_LEADS_ERR,
            payload: error && error.response
        });
    }
}


